export type OnboardingPath = 'none' | 'other_bsp' | 'wa_app';

export type StepId =
  | 'intro'
  | 'situation'
  | 'number_choice'
  | 'access_checklist'
  | 'bsp_migration_intro'
  | 'meta_tips'
  | 'migration_prep'
  | 'migration_warning'
  | 'migration_checklist';

export const WHATSAPP_LEGAL_URLS = {
  businessTerms: 'https://www.whatsapp.com/legal/business-terms',
  businessSolutionTerms: 'https://www.whatsapp.com/legal/business-solution-terms',
} as const;

export interface WhatsappChecklistCardConfig {
  icon: string;
  iconClass: string;
  titleKey: string;
  descriptionKey: string;
  linkKey?: string;
  linkUrl?: string;
}
